export default () => ({
  limitFilters: [
    {
      label: '12',
      value: 12,
    },
    {
      label: '24',
      value: 24,
    },
    {
      label: '36',
      value: 36,
    },
  ],
  autocompleteSource: null,
  autocompleteData: [],
  items: [],
  filters: {
    authorSlug: '',
    categorySlug: '',
    query: '',
  },
  orderBy: 'createdAt',
  orderDirection: 'desc',
  additionalOffset: 0,
  pagination: {
    currentPage: 1,
    limit: 12,
    offset: 0,
    countTotal: 0,
  },
  isLoading: false,
});
